import { useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';

import lang from '../../lib/language';
import { PlanPhaseTypeEnum } from '../../lib/models/crm/types';
import { RootState } from '../../lib/store';
import { getCurrentAccountTradingPlan, getCurrentDetailedAccount } from '../../lib/store/crm/helpers';

import bigThumbsUp from '../../assets/bigImages/SuccessCircle.png';
import { useIsMobile } from '../../hooks';
import BaseModal from '../../shared_components/BaseModal/BaseModal';
import Button from '../../shared_components/Button/Button';
import { ButtonTypesEnum } from '../../shared_components/Button/Button.types';
import { getModalShownStatus, REWIND_MODAL_KEY, setModalShownStatus } from '../../util/localStorageHelpers';
import { MobileDrawer } from '../index';

import styles from './RewindTradingDayModal.module.scss';

const RewindTradingDayModal = ({
  accountStatusData,
  tradingPlan,
  individualId,
  accountDetail,
}: ReduxProps) => {
  const { isMobile } = useIsMobile();
  const [showModal, setShowModal] = useState<boolean>(false);
  const { dailyResetCount, dailyResetEvent, dailyResetProcessing } = accountStatusData;
  const phase = tradingPlan?.phase;
  const isChallengePhase = phase === PlanPhaseTypeEnum.challenge;

  useEffect(() => {
    let resetCount: number | undefined;

    if (dailyResetCount > 0 && !dailyResetProcessing) {
      resetCount = dailyResetCount;
    } else if (dailyResetEvent?.isCompleted === true) {
      resetCount = dailyResetEvent?.rewindCount;
    }

    if (resetCount !== undefined && resetCount > 0 && isChallengePhase && individualId && accountDetail?.account_id) {
      const subKey = `${individualId}:${accountDetail.account_id}:${resetCount}`;
      const localStorageData = getModalShownStatus(REWIND_MODAL_KEY, 'RewindTradingDayModal');
      const isAlreadyShown = localStorageData[subKey] === true;

      if (!isAlreadyShown) {
        setModalShownStatus(REWIND_MODAL_KEY, subKey, true, 'RewindTradingDayModal');
        setShowModal(true);
      }
    }
  }, [
    dailyResetCount,
    dailyResetEvent,
    dailyResetProcessing,
    isChallengePhase,
    individualId,
    accountDetail?.account_id,
  ]);

  if (!phase) {
    return null;
  }

  const closeModal = () => setShowModal(false);

  const clickButton = () => {
    if (!showModal) return;

    closeModal();
  };

  const renderContent = () => (
    <>
      <div className={styles.iconHolder} id="rewindTradingDayModal">
        <img src={bigThumbsUp} alt="Thumb icon" />
      </div>
      <div className={styles.textWrapper}>
        <div className={styles.title}>{lang.tradingDayRewindModalTitle()}</div>
        <div className={styles.text}>
          <p>{lang.tradingDayRewindModalDescription()}</p>
        </div>
      </div>
      <div className={styles.buttonsWrapper}>
        <Button biggerFontSize fullWidth variant={ButtonTypesEnum.Primary} onClick={clickButton}>
          {lang.commonGreat()}
        </Button>
      </div>
    </>
  );

  return (
    <>
      {isMobile ? (
        <MobileDrawer
          isOpen={showModal}
          title=""
          onClose={clickButton}
          showCloseButton={false}
        >
          {renderContent()}
        </MobileDrawer>
      ) : (
        <BaseModal isOpen={showModal}>
          {renderContent()}
        </BaseModal>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  accountStatusData: state.closeout.accountStatusData,
  tradingPlan: getCurrentAccountTradingPlan(state.crm),
  individualId: state.crm.individualOrCompanyEmployeeId,
  accountDetail: getCurrentDetailedAccount(state),
});

const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export default connector(RewindTradingDayModal);
